// extracted by mini-css-extract-plugin
export default {"zoomModal":"q4-z","image":"r4-z","button":"s4-z","isOverlayShown":"t4-z"};